import React from 'react';
import { Typography, Box, Container, Grid, Stack, Paper } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import { PHONE_DISPLAY, yellowGlowSx } from '../theme';
import { QuoteForm } from './QuoteForm';
export function LeadForm() {
  return <Box component="section" id="quote-form" sx={{
    py: {
      xs: 8,
      md: 12
    },
    bgcolor: 'primary.main',
    color: 'white'
  }} data-id="element-85">
      <Container maxWidth="lg" data-id="element-86">
        <Grid container spacing={6} alignItems="center" data-id="element-87">
          <Grid item xs={12} md={6} data-id="element-88">
            <Typography variant="h6" color="secondary.main" fontWeight="bold" textTransform="uppercase" letterSpacing={1} gutterBottom sx={yellowGlowSx} data-id="element-89">
              Get Started Today
            </Typography>
            <Typography variant="h2" sx={{
            mb: 3,
            fontSize: {
              xs: '2.5rem',
              md: '3.5rem'
            }
          }} data-id="element-90">
              Request Your Free Onsite Estimate
            </Typography>
            <Typography variant="h6" sx={{
            mb: 5,
            fontWeight: 400,
            opacity: 0.9,
            lineHeight: 1.6
          }} data-id="element-91">
              Ready to transform your backyard? Fill out the form or give us a
              call. We'll discuss your vision, provide expert recommendations,
              and give you a detailed estimate.
            </Typography>

            <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            bgcolor: 'rgba(255,255,255,0.1)',
            border: '1px solid rgba(255,255,255,0.25)',
            borderRadius: 2,
            px: 2.5,
            py: 2,
            mb: 5
          }} data-id="element-92">
              <LocalFireDepartmentIcon color="secondary" data-id="element-93" />
              <Typography variant="body1" sx={{
              lineHeight: 1.5
            }} data-id="element-94">
                <Box component="span" fontWeight={700} data-id="element-95">
                  Proudly supporting our first responders & veterans. 🚒 👮
                </Box>{' '}
                Ask about our special appreciation discount for firefighters,
                police, EMTs, military, and veterans.
              </Typography>
            </Box>

            <Stack spacing={4} data-id="element-96">
              <Box sx={{
              display: 'flex',
              alignItems: 'flex-start'
            }} data-id="element-97">
                <Box sx={{
                bgcolor: 'rgba(255,255,255,0.1)',
                p: 2,
                borderRadius: 2,
                mr: 3
              }} data-id="element-98">
                  <PhoneIcon color="secondary" fontSize="large" data-id="element-99" />
                </Box>
                <Box data-id="element-100">
                  <Typography variant="body2" color="secondary.main" fontWeight="bold" textTransform="uppercase" gutterBottom sx={yellowGlowSx} data-id="element-101">
                    Call Us Directly
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" data-id="element-102">
                    {PHONE_DISPLAY}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{
              display: 'flex',
              alignItems: 'flex-start'
            }} data-id="element-103">
                <Box sx={{
                bgcolor: 'rgba(255,255,255,0.1)',
                p: 2,
                borderRadius: 2,
                mr: 3
              }} data-id="element-104">
                  <LocationOnIcon color="secondary" fontSize="large" data-id="element-105" />
                </Box>
                <Box data-id="element-106">
                  <Typography variant="body2" color="secondary.main" fontWeight="bold" textTransform="uppercase" gutterBottom sx={yellowGlowSx} data-id="element-107">
                    Service Area
                  </Typography>
                  <Typography variant="h5" fontWeight="bold" data-id="element-108">
                    Brentwood, CA & Beyond
                  </Typography>
                </Box>
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12} md={6} data-id="element-109">
            <Paper elevation={6} sx={{
            p: {
              xs: 3,
              md: 5
            },
            borderRadius: 3
          }} data-id="element-110">
              <QuoteForm data-id="element-111" />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>;
}